import { render, staticRenderFns } from "./NikoPasswordError.vue?vue&type=template&id=6d5d8abd&"
import script from "./NikoPasswordError.vue?vue&type=script&lang=js&"
export * from "./NikoPasswordError.vue?vue&type=script&lang=js&"
import style0 from "./NikoPasswordError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VSubheader})
